import modalTemplate from '../../views/modals/media-selector-modal.tpl.html';
import AlMediaSelectorModalController from '../../controllers/modals/media-selector-modal-controller';

/**
 * @todo implement allowed types
 */
export default class AlMediaFormFieldController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
        this.modal = this.injector.get('$uibModal');
        this.fileSaver = this.injector.get('FileSaver');

        this.currentSelectedFile = null;
        this.startDirectoryUuid = null;
        this.allowedMimes = [];
        this.allowedTypes = [];
        this.size = 'small';
        this.fileSelectionTrigger = () => {};

        this._initWatchers();
    }

    cleanFile() {
        this.selectedFile = null;
        this._triggerSelectedUpdate();
    }

    downloadFile() {
        return this.api.get(
            this.selectedFile.url, {
                responseType: 'blob',
                ignoreLoadingBar: true
            }
        ).then(response => {
            return this.fileSaver.saveAs(
                new Blob([response.data],
                    {
                        type: response.headers('content-type')
                    }
                ),
                this.selectedFile.name
            );
        }).catch(
            error => {
                console.error('Download error', error);
                this.alert.animatedAlert(
                    this.translate.instant('general.alerts.download_error.title'),
                    this.translate.instant('general.alerts.download_error.content'),
                    'attention',
                    {
                        showCancelButton: false,
                        confirmButtonText: this.translate.instant('general.verbs.ok')
                    }
                )
            }
        );
    }

    clipboardStatus(status) {
        if (status) {
            this.alert.success(
                this.translate.instant('general.clipboard.copy_success.title'),
                this.translate.instant('general.clipboard.copy_success.content')
            );
        } else {
            this.alert.error(
                this.translate.instant('general.clipboard.copy_error.title'),
                this.translate.instant('general.clipboard.copy_error.content')
            );
        }
    }

    fileUploadSuccess(file) {
        this.selectedFile = file;
        this.scope.$applyAsync();
    }

    fileUploadError(errorMessage) {
        // this.alert.error(
        //     this.translate.instant('media.components.form-field.alerts.upload-error.title'),
        //     errorMessage
        // );
    }

    startFileSelection() {
        this.modal.open({
            templateUrl: modalTemplate,
            size: 'mlg',
            windowClass: 'modal-fixed modal-fixed-media',
            controller: AlMediaSelectorModalController,
            controllerAs: 'vm',
            resolve: {
                startDirectory: () => {
                    if(this.selectedFile && this.selectedFile.parent) {
                        return this.selectedFile.parent.uuid;
                    }

                    return this.startDirectoryUuid || null;
                },
                allowedMimes: () => {
                    return this.allowedMimes || null;
                },
                preSelectedFile: () => {
                    return this.currentSelectedFile || null;
                }
            }
        }).result.then(({file}) => {
            this.currentSelectedFile = file.uuid;
            this.selectedFile = _.cloneDeep(file);
            this.scope.$applyAsync();
            this._triggerSelectedUpdate();
        }).catch((e) => {
        });
    }

    // Private functions
    _initWatchers() {
        this.scope.$watch(() => {
            return this.currentSelectedFile;
        }, () => {
            if (this.currentSelectedFile && (!this.selectedFile || this.selectedFile.uuid !== this.currentSelectedFile)) {
                this._loadFileInformationForCurrentSelectedFile();
            }
        });

        this.scope.$watch(() => {
            return this.selectedFile;
        }, () => {
            if (this.selectedFile) {
                this._triggerSelectedUpdate();
            }
        });
    }

    _triggerSelectedUpdate() {
        if (this.onFileSelect) {
            if (!this.loadingFileInformation) {
                this.onFileSelect({
                    file: this.selectedFile
                });
            } else {
                this.onFileSelect({
                    file: {
                        uuid: this.currentSelectedFile
                    }
                });
            }

        }
    }

    _loadFileInformationForCurrentSelectedFile() {
        this.loadingFileInformation = true;
        this.api.get(`media/files/${this.currentSelectedFile}`).then((response) => {
            this.selectedFile = _.cloneDeep(response.data.data);

            this.loadingFileInformation = false;
            this._triggerSelectedUpdate();
        }, (response) => {
            console.error('error while loading file', response);
        })
    }

}

AlMediaFormFieldController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/media/components/al-media-form-field/controller.js